module.exports = __webpack_public_path__ + "static/media/about_what_are_we.90e96181.png";